/* ==========================================================================
   New arrivals: encaje del escenario 1920×1188 (mismo patrón que el hero).
   ========================================================================== */

(function () {
  'use strict';

  /* v2: el bloque rojo es fluido (CSS); aquí solo se escala la composición
     1880×1072 para que quepa DENTRO del bloque, centrada. */
  function fit() {
    var roots = document.querySelectorAll('[data-new="root"]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      root.style.removeProperty('height'); /* limpia inline de la version anterior */
      if (window.innerWidth <= 1023) {
        root.style.removeProperty('--new-scale');
        continue;
      }
      var block = root.querySelector('[data-new="block"]');
      if (!block) continue;
      var box = block.getBoundingClientRect();
      var scale = Math.min(box.width / 1880, box.height / 1072);
      root.style.setProperty('--new-scale', Math.round(scale * 10000) / 10000);
    }
  }

  /* Mini-carrusel de destacados: flechas cambian foto + nombre + precio +
     cuota BNPL + link, con crossfade de la slide y fade del texto.
     Lote 7-oct: pasa solo (data-new-autoplay = ms por producto) y se para con el
     ratón encima, con foco de teclado dentro, mientras el dedo lo toca, con la
     pestaña oculta o fuera de pantalla; con «reducir movimiento» no pasa solo.
     En el celular también se pasa deslizando la foto con el dedo. */
  function initCarousel(root) {
    if (root.dataset.newBound === 'true') return;
    var slides = root.querySelectorAll('[data-new-slide]');
    if (slides.length < 2) return;
    root.dataset.newBound = 'true';

    var title = root.querySelector('[data-new-title]');
    var price = root.querySelector('[data-new-price]');
    var bnpl = root.querySelector('[data-new-bnpl]');
    var link = root.querySelector('[data-new-link]');
    var index = 0;
    var busy = false;

    function show(i) {
      if (busy) return;
      busy = true;
      index = (i + slides.length) % slides.length;

      for (var s = 0; s < slides.length; s++) {
        slides[s].classList.toggle('is-active', s === index);
        slides[s].tabIndex = s === index ? 0 : -1;
      }

      root.classList.add('is-swapping');
      setTimeout(function () {
        var d = slides[index].dataset;
        if (title) title.textContent = d.title;
        if (price) price.textContent = d.price;
        if (bnpl) bnpl.textContent = d.bnpl;
        if (link) link.href = d.url;
        root.classList.remove('is-swapping');
        setTimeout(function () { busy = false; }, 140);
      }, 180);
    }

    /* Autoplay: cadena de setTimeout que se rearma tras cada cambio manual */
    var delay = parseInt(root.dataset.newAutoplay, 10);
    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var timer = null;
    var holds = { hover: false, focus: false, touch: false, hidden: document.hidden, offscreen: 'IntersectionObserver' in window };

    function canRun() {
      if (!(delay > 0) || (reduce && reduce.matches)) return false;
      for (var k in holds) {
        if (holds[k]) return false;
      }
      return true;
    }

    function stop() {
      clearTimeout(timer);
      timer = null;
    }

    function restart() {
      stop();
      if (canRun()) {
        timer = setTimeout(function () {
          show(index + 1);
          restart();
        }, delay);
      }
    }

    function hold(name, on) {
      if (holds[name] === on) return;
      holds[name] = on;
      restart();
    }

    var prev = root.querySelector('[data-new-prev]');
    var next = root.querySelector('[data-new-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); restart(); });
    if (next) next.addEventListener('click', function () { show(index + 1); restart(); });

    /* Se para con el ratón sobre la foto o la ficha, no sobre toda la sección (en PC ocupa la
       pantalla entera y casi nunca pasaría sola). Solo el ratón cuenta: un toque no deja el hover pegado */
    [root.querySelector('[data-new="photo"]'), root.querySelector('[data-new-card]')].forEach(function (zona) {
      if (!zona) return;
      zona.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold('hover', true); });
      zona.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hold('hover', false); });
    });
    root.addEventListener('focusin', function (e) {
      var keyboard = true;
      try { keyboard = e.target.matches(':focus-visible'); } catch (err) { /* navegador sin :focus-visible */ }
      if (keyboard) hold('focus', true);
    });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) hold('focus', false);
    });
    root.addEventListener('touchstart', function () { hold('touch', true); }, { passive: true });
    root.addEventListener('touchend', function () { hold('touch', false); }, { passive: true });
    root.addEventListener('touchcancel', function () { hold('touch', false); }, { passive: true });
    document.addEventListener('visibilitychange', function () { hold('hidden', document.hidden); });
    if (holds.offscreen) {
      new IntersectionObserver(function (entries) {
        hold('offscreen', !entries[0].isIntersecting);
      }, { threshold: 0.25 }).observe(root);
    }
    if (reduce) {
      if (reduce.addEventListener) reduce.addEventListener('change', restart);
      else if (reduce.addListener) reduce.addListener(restart);
    }

    /* Deslizar la foto con el dedo: horizontal y claro, para no robar el scroll */
    var photo = root.querySelector('[data-new="photo"]');
    var x0 = null;
    var y0 = 0;
    var swiped = false;
    if (photo) {
      photo.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
        swiped = false;
      }, { passive: true });
      photo.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - x0;
        var dy = t.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          swiped = true;
          setTimeout(function () { swiped = false; }, 400);
          show(index + (dx < 0 ? 1 : -1));
          restart();
        }
      }, { passive: true });
      /* El toque que acaba un deslizamiento no abre el producto */
      photo.addEventListener('click', function (e) {
        if (swiped) e.preventDefault();
      }, true);
    }

    /* Sección quitada en el editor: sin delay, ningún aviso posterior (pestaña,
       pantalla, «reducir movimiento») vuelve a arrancar el autoplay */
    root._gyaaNewStop = function () {
      delay = 0;
      stop();
    };
    restart();
  }

  function init() {
    fit();
    var roots = document.querySelectorAll('[data-new="root"]');
    for (var i = 0; i < roots.length; i++) initCarousel(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(fit, 120);
  });

  document.addEventListener('shopify:section:load', init);
  /* En el editor: la sección que se quita no deja su autoplay corriendo */
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('[data-new="root"]');
    if (r && r._gyaaNewStop) r._gyaaNewStop();
  });
})();
